<template>
  <section class="content checkout-content d-flex
             justify-content-center
             align-items-center pt-0"
  >
    <div class="container">
      <div class="row">
        <agent-signup-banner>
        </agent-signup-banner>
        <div class="col-12 col-md-6  order-1 order-md-2 p-3  mb-4 card">
          <div class="form-signin">
            <h1 class="h3 mb-3 font-weight-normal"
                id="sign-in-form-head"
            >
              Login to your account
            </h1>
           <agent-login-form>
           </agent-login-form>
            <!--<existing-customervendor-login-form>-->

            <!--</existing-customervendor-login-form>-->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AgentSignupBanner from '../Agent/AgentSignupBanner'
import AgentLoginForm from '../Agent/AgentLoginForm'

export default {
	name: 'agent-login-page',
	components: {
		AgentSignupBanner,
		AgentLoginForm
	}
}
</script>

<style scoped>

</style>
